import styled from 'styled-components';
import ParkingSvg from '../../assets/amenities/parking.svg';

const ParkingIcon = styled(ParkingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default ParkingIcon;
